<cm-main-menu *ngIf="isAuthenticated && !onNonAuthenticatedRoutes" [ngClass]="{ 'minimized': !onRoot }"></cm-main-menu>

<div class="main-content-container" [ngClass]="{ 'minimized': !onRoot }">
  <router-outlet></router-outlet>
</div>

